import { Injectable, NgZone, inject } from '@angular/core';
import { App } from '@capacitor/app';
import { Observable, ReplaySubject } from 'rxjs';

/**
 * The app's single `appUrlOpen` listener. Everything that reacts to universal links / app
 * links subscribes to `url$` instead of calling `App.addListener('appUrlOpen')` itself.
 *
 * `url$` replays the latest URL, so a subscriber that only shows up after the launch URL
 * was delivered (the root component, after `platform.ready()`) still receives it. Every
 * subscriber must therefore subscribe once at startup and ignore URLs it does not handle.
 */
@Injectable({ providedIn: 'root' })
export class AppUrlService {
  private readonly zone = inject(NgZone);
  private readonly urlSubject$ = new ReplaySubject<string>(1);

  readonly url$: Observable<string> = this.urlSubject$.asObservable();

  constructor() {
    void App.addListener('appUrlOpen', ({ url }) => {
      this.zone.run(() => this.urlSubject$.next(url));
    });
  }
}
